import { Button } from "antd";
import React, { useState } from "react";
import ModalAddTrip from "../modal/ModalAddTrip";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonAddTripProps {
  // Add props here
}

const ButtonAddTrip: React.FC<ButtonAddTripProps> = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
  useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button
        onClick={showModal}
        className="font-medium"
        size="large"
        type="primary"
      >
        Thêm chuyến đi
      </Button>
      <ModalAddTrip onClose={handleCancel} visible={isModalOpen} />
    </div>
  );
};

export default ButtonAddTrip;
